import LoadingIcon from '@/assets/images/common/svg/loading.svg?react';
import classes from './index.module.scss';

export const Loading = ({
  bold,
  className,
  text = 'loading...',
}: {
  bold?: boolean;
  className?: ClassNames;
  text?: React.ReactNode;
}) => {
  return (
    <div className={cls(classes.loading, className)}>
      <div className={cls(classes.content, bold && classes.bold)}>
        <LoadingIcon className={classes.icon} />
        {text && <div className={classes.text}>{text}</div>}
      </div>
    </div>
  );
};
